var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconContextMenu = function SvgIconContextMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 4 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M2.05 2.05v.01m0 7.34v.01m0 7.34v.01m0-13.66a1.05 1.05 0 1 1 0-2.1 1.05 1.05 0 0 1 0 2.1m0 7.35a1.05 1.05 0 1 1 0-2.1 1.05 1.05 0 0 1 0 2.1m0 7.35a1.05 1.05 0 1 1 0-2.1 1.05 1.05 0 0 1 0 2.1"
  })));
};
export default SvgIconContextMenu;